import { render } from "./NewsPage.vue?vue&type=template&id=de0b8c36"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__